
export default getReadOnlyIdentifiers;
/**
 * Scans an array of imports, and determines which identifiers
   are readonly, and which cannot be assigned to. For example
   you cannot `import foo from 'foo'` then do `foo = 42`, nor
   can you `import * as foo from 'foo'` then do `foo.answer = 42`
 * @param {array} imports - the array of imports
 * @returns {array} [ importedBindings, importedNamespaces ]
 */
function getReadOnlyIdentifiers(imports) {
	var importedBindings = {},
	    importedNamespaces = {};

	imports.forEach(function (x) {
		if (x.passthrough) return;

		x.specifiers.forEach(function (s) {
			if (s.isBatch) {
				importedNamespaces[s.as] = true;
			} else {
				importedBindings[s.as] = true;
			}
		});
	});

	return [importedBindings, importedNamespaces];
}
//# sourceMappingURL=/www/ESPERANTO/esperanto/.gobble-build/01-babel/1/utils/getReadOnlyIdentifiers.js.01-babel.map